export const parseNumber = (value: unknown, fallback: number) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }

  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value)

    if (Number.isFinite(parsed)) {
      return parsed
    }
  }

  return fallback
}

const parseNonNegativeNumber = (
  value: unknown,
  fallback: number,
  unitSuffix: string,
) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.max(0, value)
  }

  if (typeof value === 'string') {
    const sanitized = value.trim().replace(unitSuffix, '')
    const parsed = Number.parseFloat(sanitized)

    if (Number.isFinite(parsed)) {
      return Math.max(0, parsed)
    }
  }

  return fallback
}

export const parsePixelNumber = (value: unknown, fallback: number) => {
  return parseNonNegativeNumber(value, fallback, 'px')
}

export const parseDelayMs = (value: unknown, fallback: number) => {
  return parseNonNegativeNumber(value, fallback, 'ms')
}

export const parsePercentString = (value: string, fallback: number) => {
  const sanitized = value.trim().replace('%', '')
  const parsed = Number.parseFloat(sanitized)

  if (!Number.isFinite(parsed)) {
    return fallback
  }

  return Math.abs(parsed)
}
